/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}",
  "sitecoreApiHost": "https://prod-my-cd.omc.osim.com",
  "jssAppName": "osim-web-shop-my",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/osim-web-shop",
  "buildTime": "Wed Jun 04 2025 14:58:01 GMT+0700 (Indochina Time)",
  "gitVersion": "884d6c7cddd37f38986b8b3433ece50dfd54d500",
  "graphQLEndpoint": "https://prod-my-cd.omc.osim.com/api/osim-web-shop?sc_apikey={6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}"
};